import React, { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Space } from "antd";
import "./edit_table_wh_transfer_in.css";
import { DataType } from "../../components/hoc_wh_transfer_in";
import ModalLocationWHin, { LocationDataType } from "./modal_location_rack_wh_in";

interface EditTableWHInProps {
    record: DataType | null;
    onFinish: (values: any) => void;
    onCancel: () => void;
    warehouseCodeTo?: string;
}

const EditTableWHIn: React.FC<EditTableWHInProps> = ({ record, onFinish, onCancel, warehouseCodeTo }) => {
    const [form] = Form.useForm();
    const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
    const qtyIn = Form.useWatch('qty_in', form);
    const qtyOut = Form.useWatch('qty_out', form);
    const isOverSupply = Boolean(qtyIn && Number(qtyIn) > Number(qtyOut || 0));

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    useEffect(() => {
        if (record) {
            form.setFieldsValue({
                item_number: record.item_number,
                item_name: record.item_name,
                uom: record.uom,
                qty_available: record.qty_available,
                qty_request: record.qty_request,
                qty_out: record.qty_out,
                qty_in: record.qty_in,
                location: record.location,
            });
        }
    }, [record, form]);

    const showLocationModal = () => {
        setIsLocationModalOpen(true);
    };

    const handleLocationCancel = () => {
        setIsLocationModalOpen(false);
    };

    const handleLocationSelect = (selectedRecord: LocationDataType) => {
        form.setFieldsValue({ location: selectedRecord.locationCode });
        setIsLocationModalOpen(false);
    };


    return (

        <div id="iiok" style={transformStyle}>
            <div className="gjs-grid-row" id="i8d9">
                <div className="gjs-grid-column" id="iyue">
                    <Form
                        form={form}
                        onFinish={onFinish}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Item Code"
                            name="item_number"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Item Name"
                            name="item_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Location Code"
                            style={{ marginBottom: "5px", width: "430px" }}
                        >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Form.Item
                                    name="location"
                                    noStyle
                                    style={{ width: "100%" }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Required!',
                                        },
                                    ]}
                                >
                                    <Input
                                        style={{ width: "100%" }}
                                        readOnly
                                    />
                                </Form.Item>
                                <Button
                                    type="primary"
                                    id="location_code_rack"
                                    onClick={showLocationModal}
                                    icon={
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="UoM"
                            name="uom"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Available Qty"
                            name="qty_available"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Request Qty"
                            name="qty_request"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Out Qty"
                            name="qty_out"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="In Qty"
                            name="qty_in"
                            style={{ marginBottom: "5px" }}
                            rules={[
                                { required: true, message: 'Required!' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (value && Number(value) > Number(getFieldValue('qty_out') || 0)) {
                                            return Promise.reject(new Error('Over Supply !'));
                                        }
                                        return Promise.resolve();
                                    },
                                }),
                            ]}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item wrapperCol={{ offset: 10, span: 14 }} style={{ paddingTop: "10px" }}>
                            <Space>
                                <Button type="primary" htmlType="submit" disabled={isOverSupply}>
                                    OK
                                </Button>
                                <Button onClick={onCancel}>
                                    Cancel
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <Modal
                title="Select Location"
                open={isLocationModalOpen}
                onCancel={handleLocationCancel}
                footer={null}
                width={800}
            >
                <ModalLocationWHin onRowDoubleClick={handleLocationSelect} warehouseCodeTo={warehouseCodeTo} />
            </Modal>
        </div>
    );
};

export default EditTableWHIn;